<template><svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 640 640">
  <g transform="rotate(180 0 320)">
    <circle fill="#fff" cx="320" cy="320" r="320" transform="translate(-640)" />
    <path d="M-160 320h-320" fill="none" stroke="#a5a19d" stroke-linecap="round" stroke-width="40" />
    <path d="M-320 480V160" fill="none" stroke="#a5a19d" stroke-linecap="round" stroke-width="40" />
  </g>
</svg>
</template>